import { render, staticRenderFns } from "./PercentageChangeCell.vue?vue&type=template&id=85c218da&scoped=true&"
import script from "./PercentageChangeCell.vue?vue&type=script&lang=js&"
export * from "./PercentageChangeCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c218da",
  null
  
)

export default component.exports